window.Foundation.registerExtension(($elem) => {
  const maps = $elem.find('[data-map]');
  if (maps.length > 0) {
    const language = $('html').attr('lang').split('-')[0];
    const key = maps.first().attr('data-map');

    const script = $(`
        <script src="https://maps.googleapis.com/maps/api/js?key=${key}&language=${language}&callback=initMaps"
        async defer></script>
    `);
    $('body').append(script);

    window.initMaps = function() {
      const infowindow = new google.maps.InfoWindow();

      maps.each(function() {
        const $this = $(this);
        const mapTypes = JSON.parse($this.attr('data-map-types'));

        const map = new google.maps.Map(this, {
          center: JSON.parse($this.attr('data-map-center')),
          zoom: parseInt($this.attr('data-map-zoom'), 10),
          mapTypeControlOptions: {
            mapTypeIds: mapTypes,
          },
          mapTypeId: mapTypes[0],
          streetViewControl: false,
        });

        const markers = JSON.parse($(this).attr('data-map-markers'));
        markers.forEach((data) => {
          const marker = new google.maps.Marker({
            map, position: data.position,
          });
          if (data.title) {
            marker.setTitle(data.title);
          }
          if (data.label) {
            marker.setLabel(data.label);
          }
          if (data.icon) {
            marker.setIcon(data.icon);
          }
          google.maps.event.addListener(marker, 'click', function () {
            infowindow.setContent(`
              <h6>${data.title}</h6>
              <p>${data.description}</p>
              <p>${data.link}</p>
            `);
            console.log(data.link);
            infowindow.open(map, this);
          });
        });
      });
    };
  }
});
